import React from 'react';
import {BulkERegistry} from './BulkERegistry';
import {MissingProposalStatus} from './MissingProposalStatus';
import Typography from '@material-ui/core/Typography';
import styles from './index.css';


const AdminUtility = () => {
    return (
        <div className={styles.base}>
            <Typography style={{marginBottom: 30, fontWeight: 'bold'}} variant="h5">Admin Utility</Typography>
            <MissingProposalStatus/>
            <br/>
            <BulkERegistry/>
            <br/>
        </div>
    );
};

export default AdminUtility;
